module.exports = __webpack_public_path__ + "assets/img/rz1.5cd01349.png";